var Node_Type = /* @__PURE__ */ ((Node_Type2) => {
  Node_Type2["PARAGRAPH"] = "PARAGRAPH";
  Node_Type2["TEXT"] = "TEXT";
  Node_Type2["HEADING"] = "HEADING";
  Node_Type2["BULLETED_LIST"] = "BULLETED_LIST";
  Node_Type2["ORDERED_LIST"] = "ORDERED_LIST";
  Node_Type2["LIST_ITEM"] = "LIST_ITEM";
  Node_Type2["BLOCKQUOTE"] = "BLOCKQUOTE";
  Node_Type2["CODE_BLOCK"] = "CODE_BLOCK";
  Node_Type2["VIDEO"] = "VIDEO";
  Node_Type2["DIVIDER"] = "DIVIDER";
  Node_Type2["FILE"] = "FILE";
  Node_Type2["GALLERY"] = "GALLERY";
  Node_Type2["GIF"] = "GIF";
  Node_Type2["HTML"] = "HTML";
  Node_Type2["IMAGE"] = "IMAGE";
  Node_Type2["LINK_PREVIEW"] = "LINK_PREVIEW";
  Node_Type2["MAP"] = "MAP";
  Node_Type2["POLL"] = "POLL";
  Node_Type2["APP_EMBED"] = "APP_EMBED";
  Node_Type2["BUTTON"] = "BUTTON";
  Node_Type2["COLLAPSIBLE_LIST"] = "COLLAPSIBLE_LIST";
  Node_Type2["TABLE"] = "TABLE";
  Node_Type2["EMBED"] = "EMBED";
  Node_Type2["COLLAPSIBLE_ITEM"] = "COLLAPSIBLE_ITEM";
  Node_Type2["COLLAPSIBLE_ITEM_TITLE"] = "COLLAPSIBLE_ITEM_TITLE";
  Node_Type2["COLLAPSIBLE_ITEM_BODY"] = "COLLAPSIBLE_ITEM_BODY";
  Node_Type2["TABLE_CELL"] = "TABLE_CELL";
  Node_Type2["TABLE_ROW"] = "TABLE_ROW";
  Node_Type2["EXTERNAL"] = "EXTERNAL";
  Node_Type2["AUDIO"] = "AUDIO";
  Node_Type2["CAPTION"] = "CAPTION";
  Node_Type2["LAYOUT"] = "LAYOUT";
  Node_Type2["LAYOUT_CELL"] = "LAYOUT_CELL";
  Node_Type2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return Node_Type2;
})(Node_Type || {});
var Decoration_Type = /* @__PURE__ */ ((Decoration_Type2) => {
  Decoration_Type2["BOLD"] = "BOLD";
  Decoration_Type2["ITALIC"] = "ITALIC";
  Decoration_Type2["UNDERLINE"] = "UNDERLINE";
  Decoration_Type2["SPOILER"] = "SPOILER";
  Decoration_Type2["ANCHOR"] = "ANCHOR";
  Decoration_Type2["MENTION"] = "MENTION";
  Decoration_Type2["LINK"] = "LINK";
  Decoration_Type2["COLOR"] = "COLOR";
  Decoration_Type2["FONT_SIZE"] = "FONT_SIZE";
  Decoration_Type2["EXTERNAL"] = "EXTERNAL";
  Decoration_Type2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return Decoration_Type2;
})(Decoration_Type || {});
export {
  Decoration_Type,
  Node_Type
};
//# sourceMappingURL=rich_content.enums.js.map
